module.exports = __webpack_public_path__ + "img/IssueVoucher.82b34d6c.svg";